import React from "react";

import "./cta-secondary.scss"


function CtaSecondary({ text, onClick }) {
    return(
        <button className="cta-secondary" onClick={onClick}>{text}</button>
    )
}

export default CtaSecondary